import React from 'react';
import './SplashScreen.css';

const SplashScreen: React.FC = () => {
  return (
    <div className="splash-screen">
      <div className="splash-content">
        <div className="logo-container">
          <div className="logo-icon">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
              <circle cx="30" cy="30" r="25" fill="#004b5b" />
              <path d="M20 30 L28 38 L40 22" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h1 className="app-name">
            <span className="spark">Spark</span>
            <span className="ademy">ademy</span>
          </h1>
        </div>
        <div className="loading-spinner"></div>
      </div>
    </div>
  );
};

export default SplashScreen;

